import React from 'react';
import { StarIcon } from 'lucide-react';
import { REVIEWS } from '../lib/content';
export function Reviews() {
  return <div className="space-y-3" data-id="element-161">
      {REVIEWS.map((r, i) => <div key={i} className="rounded-xl border border-neutral-700 bg-neutral-900/80 p-4 backdrop-blur-sm" data-id="element-162">
          <div className="flex items-center gap-1" data-id="element-163">
            {Array.from({
          length: 5
        }).map((_, s) => <StarIcon key={s} className="h-4 w-4 fill-orange-400 text-orange-400" data-id="element-164" />)}
          </div>
          <p className="mt-2 text-sm leading-relaxed text-neutral-200" data-id="element-165">
            “{r.text}”
          </p>
          <p className="mt-2 text-xs font-semibold text-neutral-400" data-id="element-166">
            {r.name} · {r.location}
          </p>
        </div>)}
    </div>;
}